import { Box, useTheme } from '@mui/material';
import List from 'components/list/list';
import ListCell from 'components/list/list-cell';
import ListRow from 'components/list/list-row';
import React from 'react';
import { useIntl } from 'react-intl';
import { ScenarioCageData } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-cage-data.type';

type ExcludedFishGroupsListProps = {
  cageData: ScenarioCageData[];
};

const ExcludedFishGroupsList: React.FC<ExcludedFishGroupsListProps> = ({ cageData }) => {
  const theme = useTheme();
  const intl = useIntl();

  if (cageData.length === 0) {
    return null;
  }

  const columns = [
    {
      id: 'fishGroup',
      label: intl.formatMessage({ id: 'bluViuNutrition.applyFeed.excludedFishGroups.title' }),
      sx: { fontWeight: 'normal', fontSize: 16 },
      align: 'left' as const,
    },
  ];

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <List
        dark
        options={columns}
        sx={{
          ['.MuiTableCell-body']: {
            backgroundColor: theme.palette.darkBlue.o25,
          },
        }}
      >
        {cageData.map((cage) => (
          <ListRow key={cage.id}>
            <ListCell>{cage.fishGroupName}</ListCell>
          </ListRow>
        ))}
      </List>
    </Box>
  );
};

export default ExcludedFishGroupsList;
